import { SupportedLang } from "@/app/core/models/supportedLang";

export interface OpponentData {
	id: string;
	imageUrl: string;
	name: string;
	shortname: string;
}

export interface CompetitionData {
	id: string;
	iconUrl: string;
	name: string;
}

export interface EventCalendar {
	id?: string;
	datetime: string;
	streamUrl?: string;
	calendarType?: 'EVENT' | 'MATCH';

	translations: Record<SupportedLang, EventTranslation>;

	competitionName?: string;
	competitionImageKey?: string;
	competitionImageWidth?: number;
	competitionImageHeight?: number;

	opponent?: string;
	opponentImageKey?: string;
	opponentImageWidth?: number;
	opponentImageHeight?: number;
	score?: string;
	opponentScore?: string;
	vodUrl?: string;
	eventType?: EventType;
	ticketUrl?: string;
	opponentData?: OpponentData;
	competitionData?: CompetitionData;
}

export interface EventTranslation {
	name: string;
}

export type EventType = 'CLUB' | 'OVERWATCH_PRO' | 'OVERWATCH_ACADEMY' | 'MARVEL_RIVALS' | 'POKEMON_VGC' | 'POKEMON_UNITE' | 'DOFUS' | 'OVERWATCH_BUNDLE';

export const EventTypeList: EventType[] = [
	'CLUB',
	'OVERWATCH_PRO',
	'OVERWATCH_ACADEMY',
	'OVERWATCH_BUNDLE',
	'MARVEL_RIVALS',
	'POKEMON_VGC',
	'POKEMON_UNITE',
	'DOFUS'
]

export interface EventTypeItem {
	type: EventType;
	image: string;
	label: string;
	alt: string;
}

export const EventTypeWithImageList: EventTypeItem[] = [
	{
		type: 'CLUB',
		image: 'assets/images/team_peps_logo.avif',
		label: 'CLUB',
		alt: 'Team Peps Logo'
	},
	{
		type: 'OVERWATCH_PRO',
		image: 'assets/images/max_button/max_button_overwatch.png',
		label: 'OW Pro',
		alt: 'Team Peps Overwatch Pro Logo'
	},
	{
		type: 'OVERWATCH_BUNDLE',
		image: 'assets/images/icon_roster_buypepsbundle.png',
		label: 'BuyPepsBundle',
		alt: 'Buy Peps Bundle Logo'
	},
	{
		type: 'OVERWATCH_ACADEMY',
		image: 'assets/images/peps_academy_logo.png',
		label: 'OW Academy',
		alt: 'Team Peps Overwatch Academy Logo'
	},
	{
		type: 'MARVEL_RIVALS',
		image: 'assets/icons/Marvel_Rivals_logo.svg',
		label: 'Marvel Rivals',
		alt: 'Team Peps Marvel Rivals Logo'
	},
	{
		type: 'POKEMON_VGC',
		image: 'assets/icons/pokemon_vgc_logo.svg',
		label: 'Pokemon VGC',
		alt: 'Team Peps Pokemon VGC Logo'
	},
	{
		type: 'POKEMON_UNITE',
		image: 'assets/icons/pokemon_unite_logo_filter.png',
		label: 'Pokemon Unite',
		alt: 'Team Peps Pokemon Unite Logo'
	},
	{
		type: 'DOFUS',
		image: 'assets/images/logo/dofus.png',
		label: 'Dofus',
		alt: 'Team Peps Dofus Logo'
	}
];
